import React from "react";

function HighlightSearchTerm({title, searchTerm, invertHighlight}) {
    if (searchTerm === undefined) {
        return title;
    }
    // Suchbegriff in ein Array von Wörtern konvertieren
    const searchTerms = Array.isArray(searchTerm) ? searchTerm : [searchTerm];
    for (let i = 0; i < searchTerms.length; i++) {
        if (searchTerms[i].length === 0) {
            searchTerms.splice(i, 1);
        }
    }

    if (searchTerms.length === 0) {
        return title;
    }
    // Funktion zum Erstellen eines Spans mit dem Suchbegriff
    const createHighlightSpan = (term, index) => {
        return <span className="highlight" key={index}>{term}</span>;
    };

    // Titel in ein Array von Textknoten und Suchbegriffen zerlegen
    const titleParts = title.split(new RegExp(`(${searchTerms.join("|")})`, "i"));

    if (titleParts.length === 1) {
        return <span className="highlight">{titleParts.join("")}</span>;

    }
    // Textknoten und Spans mit Suchbegriffen zusammenfügen
    const highlightedTitle = titleParts.map((part, index) => {
        if (searchTerms.includes(part.toLowerCase())) {
            return createHighlightSpan(part, index);
        }
        return <span key={index}>{part}</span>;

    });

    return (
        <>
            {highlightedTitle}
        </>
    );
}

export default HighlightSearchTerm;
